import { AttachedObjectResponse } from "@/Common/Models/FileSelection/Responses/AttachedObject";
import { BasePreventiveActivitiesDisplayItemsPopup, IBasePreventiveActivitiesDisplayItemsPopup } from "./BasePreventiveActivitiesDisplayItemsPopup";

interface IPreventiveActivitiesAttachmentsPopup extends IBasePreventiveActivitiesDisplayItemsPopup {
    attachments: AttachedObjectResponse[];
    onAttachmentClick: (attachment: AttachedObjectResponse) => void;
}

class PreventiveActivitiesAttachmentsPopup extends BasePreventiveActivitiesDisplayItemsPopup<IPreventiveActivitiesAttachmentsPopup, never> {
    protected getHeader(): string {
        return cacheStore.GetString("AttachmentsLabel");
    }

    protected getBody(): React.ReactNode {
        return this.props.attachments?.map(attachment => (
            <div key={attachment.Id}>
                <a onClick={() => this.onAttachmentClick(attachment)}>{attachment.Description}</a>
            </div>
        ));
    }

    protected shouldTriggerOkActionOnOutsideClick(): boolean {
        return true;
    }

    private onAttachmentClick(attachment: AttachedObjectResponse): void {
        if (!attachment)
            return null;

        this.props.onAttachmentClick(attachment);
        this.props.onClosed();
    }
}

export { PreventiveActivitiesAttachmentsPopup };
